module.exports = __webpack_public_path__ + "static/VPwhite-4034e95b1fb6fdde06046d8f114aae1b.png";